import { useState, useCallback } from 'react';

const KEY = 'tsanga_intro_seen';

/**
 * Session-scoped first-visit detector for the cinematic intro.
 * Returns [isFirstVisit, markSeen] — the boolean flips to false after markSeen()
 * and stays false for the rest of the browser session (sessionStorage).
 * Safe in private-mode Safari where sessionStorage may throw.
 */
export function useFirstVisit() {
  const [isFirstVisit, setIsFirstVisit] = useState(() => {
    if (typeof window === 'undefined') return false;
    try {
      return sessionStorage.getItem(KEY) !== '1';
    } catch {
      return false;
    }
  });

  const markSeen = useCallback(() => {
    try {
      sessionStorage.setItem(KEY, '1');
    } catch {
      /* private mode — ignore */
    }
    setIsFirstVisit(false);
  }, []);

  return [isFirstVisit, markSeen];
}
